const HUMAN_SPEED = 1.39;

const getTimeToStation = distance => {
  const timeInSeconds = distance / HUMAN_SPEED;
  const getHours = seconds => Math.floor(seconds / 3600);
  const getMinutes = seconds => Math.floor(seconds / 60);

  if (timeInSeconds > 3600) {
    return `${getHours(timeInSeconds)} ч. пешком`;
  }

  if (timeInSeconds > 60) {
    return `${getMinutes(timeInSeconds)} мин. пешком`;
  }

  return `${timeInSeconds} сек. пешком`;
};

const getDistanceInWords = distance => {
  if (distance <= 999) {
    return `${Math.floor(distance)} м`;
  }

  return `${Math.floor(distance / 100) / 10} км`.replace('.', ',');
};

const getStationRoute = () => ({
    routeDescription: '14 минут на общественном транспорте',
    routeParts: [
      {
        type: 'walking',
        description: '2 мин',
      },
      {
        type: 'bus',
        description: '281, 281к, 144к  до ост. «ул. Академика Варги, д. 28»',
      },
      {
        type: 'walking',
        description: '1 мин',
      },
    ],
  });

const getOfficeUndergrounds = (office, undergrounds) => {
  const { metroLocations } = office.address;

  return metroLocations.reduce((accum, metroLocation) => {
    const officeStation = undergrounds.find(underground =>
      underground.ids.includes(`${metroLocation.metroStationId}`)
    );

    if (officeStation) {
      const colorIndex = officeStation.ids.findIndex(
        id => id === `${metroLocation.metroStationId}`
      );

      return [
        ...accum,
        {
          color: officeStation.colors[colorIndex],
          name: officeStation.name,
          time: getTimeToStation(metroLocation.distance),
          distance: getDistanceInWords(metroLocation.distance),
          route: getStationRoute(),
        },
      ];
    }

    return accum;
  }, []);
};

export default getOfficeUndergrounds;
